var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import BaseButton from './atoms/BaseButton';
import SessionLinks from './SessionLinks';
import SessionContainer from './SessionContainer';
import { useNotify } from '../hooks/notificationHook';
import { useChangePassword } from '../hooks/sessionHook';
var ChangePasswordForm = function (_a) {
    var _b, _c;
    var role = _a.role;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var location = useLocation();
    var notify = useNotify();
    var passwordRef = React.createRef();
    var passwordConfirmationRef = React.createRef();
    var _d = React.useState(true), firstAccess = _d[0], setFirstAccess = _d[1];
    var changePassword = useChangePassword();
    var query = qs.parse(location.search.slice(1));
    React.useEffect(function () {
        if (!query.error)
            return;
        notify('error', [t('messages.changePasswordTokenError')]);
        navigate("/".concat(role, "/password/reset"));
    }, [t, role, query, notify, navigate]);
    var handleChangePassowrd = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var password, passwordConfirmation, credentials, response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    event.preventDefault();
                    password = (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.value;
                    passwordConfirmation = (_b = passwordConfirmationRef.current) === null || _b === void 0 ? void 0 : _b.value;
                    if (!password || !passwordConfirmation)
                        return [2 /*return*/];
                    credentials = firstAccess
                        ? {
                            'access-token': query['access-token'],
                            client: query.client,
                            uid: query.uid,
                        }
                        : undefined;
                    setFirstAccess(false);
                    return [4 /*yield*/, changePassword(password, passwordConfirmation, role, credentials)];
                case 1:
                    response = _c.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.changePasswordSuccess')]);
                    navigate("/".concat(role));
                    return [2 /*return*/];
            }
        });
    }); }, [
        passwordRef,
        passwordConfirmationRef,
        navigate,
        notify,
        firstAccess,
        setFirstAccess,
        role,
        t,
        query,
        changePassword,
    ]);
    return (React.createElement(SessionContainer, { role: role },
        React.createElement("form", null,
            React.createElement(Grid, { container: true, spacing: 3 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { inputRef: passwordRef, fullWidth: true, inputProps: (_b = {}, _b['aria-label'] = 'Password', _b.role = 'textbox', _b), label: t('password'), name: "password", size: "small", type: "password", variant: "outlined" })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { inputRef: passwordConfirmationRef, fullWidth: true, inputProps: (_c = {},
                            _c['aria-label'] = 'Password Confirmation',
                            _c.role = 'textbox',
                            _c), label: t('passwordConfirmation'), name: "passwordConfirmation", size: "small", type: "password", variant: "outlined" })),
                React.createElement(Grid, { item: true, xs: 1 }),
                React.createElement(Grid, { item: true, xs: 10 },
                    React.createElement(BaseButton, { fullWidth: true, type: "submit", onClick: handleChangePassowrd }, t('buttons.changePassword')),
                    React.createElement(SessionLinks, { role: role, showLogin: true }))))));
};
export default ChangePasswordForm;
